// extracted by mini-css-extract-plugin
module.exports = {"container":"_3HIql","titleContainer":"_2LrTv","title":"_2dWcN","message":"_2Zlp5","reason":"_2wBw2","separator":"lElbN","radioInput":"_3mqxA","form":"_2rnNa","reasons":"_1MGWV"};